/*
This file contains functions to call the api client backends.
*/
import { saasServiceName } from './constants.js'

const authedStoreFn = 'callAuthedAPI'
const authedOrAnonStoreFn = 'callAuthedOrAnonAPI'

import { useUserManagementClientStoreStore } from 'stores/saasUserManagementClientStore'

/*
One entry here for ecery prefix ins the python backend app
 matches prefixes foudn in /services/src/APIs/__init__.py
*/
const apiPrefixes = {
  info: { // baseapp provided endpoint
    endpoint: saasServiceName,
    path: '/info',
    storeFn: authedOrAnonStoreFn, // authedStoreFn or authedOrAnonStoreFn
    orveridePublicPrivatePart: 'public' // public or private
  },
  entity: { // baseapp provided endpoint
    endpoint: saasServiceName,
    path: '/entity',
    storeFn: authedOrAnonStoreFn, // authedStoreFn or authedOrAnonStoreFn
    orveridePublicPrivatePart: 'public' // public or private
  },
  processes: {
    endpoint: saasServiceName,
    path: '/processes',
    storeFn: authedStoreFn, // authedStoreFn or authedOrAnonStoreFn
    orveridePublicPrivatePart: 'private' // public or private
  },
  chat: {
    endpoint: saasServiceName,
    path: '/chat',
    storeFn: authedStoreFn, // authedStoreFn or authedOrAnonStoreFn
    orveridePublicPrivatePart: 'private' // public or private
  }
}

function callApi ({
  prefix, // must match prefix from apiPRefixes array
  router,
  path, // : queryString,
  method, // : 'get',
  postdata, // : null,
  callback, // : callback,
  tenantName
}) {
  if (typeof (apiPrefixes[prefix]) === 'undefined') {
    console.log('ERROR invalid prefix provided to callAPI - ', prefix, apiPrefixes)
    return
  }
  let curpath // = undefined
  if (typeof (router) !== 'undefined') {
    curpath = router.currentRoute.value.fullPath
  }
  const getPathFn = function (tenantName, prefix, path) {
    if (typeof (tenantName) === 'undefined') {
      return apiPrefixes[prefix].path + path
    }
    return apiPrefixes[prefix].path + '/' + tenantName + path
  }
  const userManagementClientStore = useUserManagementClientStoreStore()
  userManagementClientStore[apiPrefixes[prefix].storeFn]({
    endpoint: apiPrefixes[prefix].endpoint,
    path: getPathFn(tenantName, prefix, path),
    method,
    postdata,
    callback,
    curpath,
    orveridePublicPrivatePart: apiPrefixes[prefix].orveridePublicPrivatePart
  })
}

export default {
  callApi
}
